import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import 'bootstrap';
import 'slick-carousel';

jQuery(document).ready(($) => {
	const MsideScripts = {
		init() {

			this._initJs();
			this._initUndergradSearch();
			this._initGradSearch();
			this._initCompare();
			this._initActivitiesDropdown();
			this._initNewsDropdown();
			this._initStoryDropdown();
			this._initAnimations();
			this._initCarouselBlock();
			this._initEventsBlock();
			this._initSearch();
			this._initHomeCarouselBlock();
			this._initMeetFacultyBlock();
			this._initNewsBlock();
			this._initStangStoriesBlock();
			this._initStoryBlock();
			this._initSideMenu();
			this._initStickyMenu();
			this._initProgramFinder();

		},
		_initJs() {
			$(document.documentElement).removeClass('no-js').addClass('js');
		},
		_initUndergradSearch() {

			const filterUndergradPrograms = function() {
				let searchQuery = $('.undergrad-programs-block .search-field').val();
				const filter    = $('.undergrad-programs-block .filter-field').val();
				const school    = $('.undergrad-programs-block .school-field').val();

				if(searchQuery) {
					searchQuery = searchQuery.toLowerCase();
				}

				$('.undergrad-programs-block .degree-item-element').each(function(index) {
					let keywords  = $(this).data('keywords');
					const types   = $(this).data('type');
					const schools = $(this).data('school');

					if(keywords) {
						keywords = keywords.toLowerCase();
					}

					$(this).show();

					if(!keywords.includes(searchQuery)) {
						$(this).hide();
					}

					if(filter) {
						if(!types.includes(filter)) {
							$(this).hide();
						}
					}


					if(school) {
						if(!schools.includes(school)) {
							$(this).hide();
						}
					}
				});
			}

			$('.undergrad-programs-block .search-field').on('change keyup blur input', function(e) {
				filterUndergradPrograms();
				e.preventDefault();
				return false;
			});

			$('.undergrad-programs-block .filter-field').on('change', function(e) {
				filterUndergradPrograms();
				e.preventDefault();
				return false;
			});

			$('.undergrad-programs-block .school-field').on('change', function(e) {
				filterUndergradPrograms();
				e.preventDefault();
				return false;
			});

		},
		_initGradSearch() {

			const filterGradPrograms = function() {
				let searchQuery = $('.grad-programs-block .search-field').val();
				const filter    = $('.grad-programs-block .filter-field').val();
				const school    = $('.grad-programs-block .school-field').val();

				if(searchQuery) {
					searchQuery = searchQuery.toLowerCase();
				}

				$('.grad-programs-block .degree-item-element').each(function(index) {
					let keywords  = $(this).data('keywords');
					const types   = $(this).data('type');
					const schools = $(this).data('school');

					if(keywords) {
						keywords = keywords.toLowerCase();
					}

					$(this).show();

					if(!keywords.includes(searchQuery)) {
						$(this).hide();
					}

					if(filter) {
						if(!types.includes(filter)) {
							$(this).hide();
						}
					}


					if(school) {
						if(!schools.includes(school)) {
							$(this).hide();
						}
					}
				});
			}

			$('.grad-programs-block .search-field').on('change keyup blur input', function(e) {
				filterGradPrograms();
				e.preventDefault();
				return false;
			});

			$('.grad-programs-block .filter-field').on('change', function(e) {
				filterGradPrograms();
				e.preventDefault();
				return false;
			});

			$('.grad-programs-block .school-field').on('change', function(e) {
				filterGradPrograms();
				e.preventDefault();
				return false;
			});

		},
		_initCompare() {

			let selectedProgramIds = [];
			const $compareCheckedDiv = $(".compare-checked");

			window.onload = function() {
				$(".checkbox-compare").prop("checked", false);
			};

			$(".checkbox-compare").change(function () {
				const $checkedPrograms = $(".checkbox-compare:checked");
				const $compareItems = $(".compare-item p");

				$compareItems.empty();
				selectedProgramIds = [];

				if ($checkedPrograms.length >= 3) {
					$(".checkbox-compare:not(:checked)").prop("disabled", true)
				} else {
					$(".checkbox-compare").prop("disabled", false);
				}

				$checkedPrograms.each(function (index) {


						const programName = $(this).data("name");
						const programId = $(this).data("id");
						selectedProgramIds.push(programId);
						$($compareItems[index]).text(programName);
						$($compareItems[index]).closest(".compare-item").addClass("has-item");

				});

				$compareItems.each(function () {
					if (!$(this).text().trim()) {
						$(this).closest(".compare-item").removeClass("has-item");
					}
				});

				if ($checkedPrograms.length > 0) {
						$compareCheckedDiv.slideDown();
				} else {
						$compareCheckedDiv.slideUp();
				}
			});

			$(".compare-button button").click(function () {
				if (selectedProgramIds.length > 0) {
					const url = "/academics/compare/?programs=" + selectedProgramIds.join(",");
					// Redirect to the comparison URL
					window.location.href = url;
				} else {
					alert("Please select at least one program to compare.");
				}
			});
		},
		_initActivitiesDropdown() {
			$('.activities-block .activity-filter').change(function(e) {
				const searchQuery = $('.activities-block .activity-filter').val();
				$('.activities-block .activity').hide();
				let count = 0;
				$('.activities-block .activity').each(function(index) {
					const categories = $(this).data('category');
					if(!categories.includes(searchQuery)) {
						$(this).fadeOut();
					} else {
						$(this).fadeIn();
						count++;
					}

					$('.activities-block .activity-count').text(count);
				});
			});
		},
		_initNewsDropdown() {
			$('.blog .category-select, .category .category-select').change(function(e) {
				window.location = $(e.currentTarget).val();
				e.preventDefault();
			});
		},
		_initStoryDropdown() {
			const $categorySelect = $('.stang-stories .category-select');
			const $header = $('.category-header');

			const categoryMapping = {
					'alumni' : 'Alumni',
					'current-students' : 'Current Students',
				};

			$categorySelect.change(function(e) {
				const searchQuery = $categorySelect.val();

				const categoryName = categoryMapping[searchQuery] || 'All Stories';

				$header.text(categoryName);


				$('.stang-stories--archive-listing .column-card').hide();
				$('.stang-stories--archive-listing .column-card').each(function(index) {
					const types = $(this).data('type');
					if(!types.includes(searchQuery)) {
						$(this).fadeOut();
					} else {
						$(this).fadeIn();
					}
				});
			});
		},
		_initAnimations() {
			// Headings
			$('.stats-block .wp-block-heading,.carousel-block .wp-block-heading,.accordion-block .wp-block-heading,.stacked-squares-block .wp-block-heading, .inner-callout .wp-block-heading, .find-program-block .section-title, .featured-block .wp-block-heading, .video-block .wp-block-heading, .columns-block .row > .wp-block-heading, .news-block .title-container, .events-block .title-container, .stang-stories-block .heading-image, .story-block .heading-image, .text-block h2.wp-block-heading, .courses-field h2')
				.attr('data-aos', 'fade-down')
				.attr('data-aos-delay', 100);

			$('.intro-block .subpage-title-bar')
				.attr('data-aos', 'fade')
				.attr('data-aos-delay', 100);
			$('.intro-block h1')
				.attr('data-aos', 'fade-right')
				.attr('data-aos-delay', 100);
			$('.intro-block .wp-block-buttons')
				.attr('data-aos', 'fade-left')
				.attr('data-aos-delay', 100);
			$('.intro-text-block h2')
				.attr('data-aos', 'fade-down')
				.attr('data-aos-anchor-placement', 'bottom-bottom')
				.attr('data-aos-delay', 100);
			$('.intro-text-block img')
				.attr('data-aos', 'fade')
				.attr('data-aos-delay', 100);
			$('.image-text-block.has-image-on-the-left .column-image')
				.attr('data-aos', 'fade-right')
			$('.image-text-block.has-image-on-the-left .column-text')
				.attr('data-aos', 'fade-left')
				.attr('data-aos-delay', 200)
			$('.image-text-block:not(.has-image-on-the-left) .column-image')
				.attr('data-aos', 'fade-left')
			$('.image-text-block:not(.has-image-on-the-left) .column-text')
				.attr('data-aos', 'fade-right')
				.attr('data-aos-delay', 200)
			// $('.stacked-squares-block .wp-block-heading')
			//  .attr('data-aos', 'fade')
			//  .attr('data-aos-delay', 100);
			$('.accordion-block .accordion-item')
				.attr('data-aos', 'fade-up')
				.attr('data-aos-delay', 200);
			// $('.accordion-block .wp-block-heading')
			//  .attr('data-aos', 'fade-left')
			//  .attr('data-aos-delay', 100);
			$('.carousel-block img')
				.attr('data-aos', 'fade')
				.attr('data-aos-delay', 200);
			// $('.carousel-block .wp-block-heading')
			//  .attr('data-aos', 'fade-down')
			//  .attr('data-aos-delay', 100);

			$('.inner-callout')
				.attr('data-aos', 'zoom-in')
				.attr('data-aos-delay', 0);

			$('.find-program-block .program-image')
				.attr('data-aos', 'zoom-out')
				.attr('data-aos-delay', 0);

			$('.featured-block .column-image .img-fluid')
				.attr('data-aos', 'zoom-out')
				.attr('data-aos-delay', 0);

			$('.featured-block .column-graphics .img-fluid')
				.attr('data-aos', 'zoom-out')
				.attr('data-aos-delay', 100);

			$('.video-block .wp-block-embed')
				.attr('data-aos', 'fade')
				.attr('data-aos-delay', 100);

			$('.quote-block blockquote')
				.attr('data-aos', 'zoom-in')
				.attr('data-aos-delay', 100);

			$('.grad-panel .degree-element')
				.attr('data-aos', 'fade-right')
			$('.grad-panel .great-fit')
				.attr('data-aos', 'fade-left')
				.attr('data-aos-delay', 200)

			$('.stats-block').each(function() {
				let cardDelay = 100;
				$(this).find('.column-stat').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade')
						.attr('data-aos-delay', 100);
					$(this).find('p:first-child')
						.attr('data-aos', 'flip-up')
						.attr('data-aos-delay', cardDelay);
				});
			});

			$('.stacked-squares-block').each(function() {
				let cardDelay = 100;
				$(this).find('.column-square').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade-up')
						.attr('data-aos-delay', cardDelay);
				});
			});

			$('.cards-block').each(function() {
				let cardDelay = 100;
				$(this).find('.column-card').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade-up')
						.attr('data-aos-delay', cardDelay);
				});
			});

			$('.undergrad-feature-panel').each(function() {
				let cardDelay = 100;
				$(this).find('.column-card').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade-up')
						.attr('data-aos-delay', cardDelay);
				});
			});

			$('.columns-block').each(function() {
				let cardDelay = 100;
				$(this).find('.column-inner').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade-down')
						.attr('data-aos-delay', cardDelay);
				});
			});

			$('.news-block,.events-block,.stang-stories-block:not(.stang-stories--archive-listing),.story-block').each(function() {
				let cardDelay = 100;
				$(this).find('article').each(function() {
					cardDelay += 100;
					$(this)
						.attr('data-aos', 'fade-down')
						.attr('data-aos-delay', cardDelay);
				});
			});

			AOS.init({
				delay: 0, // values from 0 to 3000, with step 50ms
				duration: 600, // values from 0 to 3000, with step 50ms
				easing: 'ease', // default easing for AOS animations
				once: true, // whether animation should happen only once - while scrolling down
			});
		},

		_initCarouselBlock() {
			$('.wp-block-gallery.has-nested-images').slick({
				autoplay: true,
				centerMode: true,
				infinite: true,
				speed: 500,
				fade: true,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity="0.4" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity="0.4" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				cssEase: 'linear',
			});
			AOS.refresh();
		},

		_initStangStoriesBlock() {
			$('.stang-stories-block .slide-wrapper').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				// dots: true,
				autoplay: true,
				autoplaySpeed: 3000,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity=".2" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity=".2" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				responsive: [
					{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true,
					}
					},
					{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						prevArrow: null,
						nextArrow: null,
					}
					},
					{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
					]
				// cssEase: 'linear',
			});
			AOS.refresh();
		},

		_initHomeCarouselBlock() {
			$('.home-carousel-block .carousel-wrapper').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				centerMode: true,
				infinite: true,
				speed: 500,
				fade: true,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity="0.4" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity="0.4" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				cssEase: 'linear',
			});
			AOS.refresh();
		},

		_initStoryBlock() {
			$('.story-block .slide-wrapper').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity=".2" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#000" fill-opacity=".2" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				responsive: [
					{
					breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
					]
				// cssEase: 'linear',
			});
			AOS.refresh();
		},

		_initMeetFacultyBlock() {
			$('.meet-faculty-block .slide-wrapper').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#ffffff" fill-opacity=".8" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#ffffff" fill-opacity=".8" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
					]
				// cssEase: 'linear',
			});
			AOS.refresh();
		},

		_initNewsBlock() {
			$('.news-block .slide-wrapper').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 5000,
				mobileFirst: true,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#393939" fill-opacity=".8" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#393939" fill-opacity=".8" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				responsive: [
					{
						breakpoint: 576,
						settings: 'unslick',
					},
				]
			});
			AOS.refresh();
		},

		_initEventsBlock() {
			$('.events-block .slide-wrapper').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 5000,
				mobileFirst: true,
				prevArrow:
					'<button class="slick-prev" title="Previous Slide" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#393939" fill-opacity=".8" d="m16.5 0 5 5-11 11 11 11-5 5-16-16 16-16Z"/></svg></button>',
				nextArrow:
					'<button class="slick-next" title="Next Slide" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 32"><path fill="#393939" fill-opacity=".8" d="m5.5 0-5 5 11 11-11 11 5 5 16-16-16-16Z"/></svg></button>',
				responsive: [
					{
						breakpoint: 576,
						settings: 'unslick'
					}
				]
			});
			AOS.refresh();
		},

		_initSearch() {
			$( 'body' ).on( 'click', '.top-nav-bar .search.not-active', ( e ) => {
				$( '.search-overlay' ).fadeIn( 200, () => {
					$( '.search-overlay' ).addClass( 'active' );
					$( '.search-overlay' ).attr('aria-hidden', 'false');
					$( '#search-field' ).focus();
					$( e.currentTarget ).addClass( 'active' );
					$( e.currentTarget ).attr('aria-expanded', 'true');
					$( e.currentTarget ).removeClass( 'not-active' );
					$( e.currentTarget ).attr( 'title', 'Close search' );
					$( 'body' ).addClass( 'fixed-body' );
				} );
			} );

			$( '.search-content a, .search-overlay.active button, .utility-nav .search.active, #search-field' ).keydown( (e) => {
				if (e.key === 'Esc' || e.key === 'Escape') {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'false');
						$( '.top-nav-bar .search' ).removeClass( 'active' );
						$( '.top-nav-bar .search' ).attr('aria-expanded', 'true');
						$( '.top-nav-bar .search' ).addClass( 'not-active' );
						$( '.top-nav-bar .search' ).attr( 'title', 'Search site' );
						$( '.top-nav-bar .search' ).focus();
						$( 'body' ).removeClass( 'fixed-body' );
					} );
				}
			} );

			$( '#search-field' ).keydown( (e) => {
				if (e.key === 'Tab' && e.shiftKey) {
					$('.top-nav-bar .search').focus();
					e.preventDefault();
				}
			} );

			$( '.top-nav-bar .search.active' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$('#search-field').focus();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.search-links li:last-child a', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'false');
						$( '.top-nav-bar .search' ).removeClass( 'active' );
						$( '.top-nav-bar .search' ).attr('aria-expanded', 'true');
						$( '.top-nav-bar .search' ).addClass( 'not-active' );
						$( '.top-nav-bar .search' ).attr( 'title', 'Search site' );
						$( 'body' ).removeClass( 'fixed-body' );
						// setTimeout(() => {
						$( '.top-nav-bar .search' ).first().focus();
						// }, 400);
					} );
					e.preventDefault();
				}
			} );

			$( '.search-results .results-sort' ).change( function() {
				const sort = $(this).val();

				const url = new URL(location.href);
				url.searchParams.set('sort', sort);
				window.location = url;
			});

			$( 'body' ).on( 'click', '.top-nav-bar .search.active', ( e ) => {
				if ( $( '.search-overlay' ).is( ':visible' ) ) {
					$( '.search-overlay' ).fadeOut( 200, () => {
						$( '.search-overlay' ).removeClass( 'active' );
						$( '.search-overlay' ).attr('aria-hidden', 'true');
						$( '.top-nav-bar .search' ).removeClass( 'active' );
						$( '.top-nav-bar .search' ).attr('aria-expanded', 'false');
						$( '.top-nav-bar .search' ).addClass( 'not-active' );
						$( '.top-nav-bar .search' ).attr( 'title', 'Search site' );
						$( 'body' ).removeClass( 'fixed-body' );
					} );
				}
			} );

			$( '.top-nav-bar .search.active, button.search-close' ).click( ( e ) => {
				$( '.search-overlay' ).fadeOut( 200 );
				$( '.search-overlay' ).removeClass( 'active' );
				$( '.search-overlay' ).attr('aria-hidden', 'true');
				$( '.top-nav-bar .search' ).removeClass( 'active' );
				$( '.top-nav-bar .search' ).attr('aria-expanded', 'false');
				$( '.top-nav-bar .search' ).addClass( 'not-active' );
				$( '.top-nav-bar .search' ).attr( 'title', 'Search site' );
				$( 'body' ).removeClass( 'fixed-body' );
			} );

			$( '.search-overlay .close' ).click( ( e ) => {
				$( '.search-overlay' ).fadeOut( 200 );
				$( '.search-overlay' ).removeClass( 'active' );
				$( '.search-overlay' ).attr('aria-hidden', 'true');
				$( '.top-nav-bar .search' ).removeClass( 'active' );
				$( '.top-nav-bar .search' ).attr('aria-expanded', 'false');
				$( '.top-nav-bar .search' ).addClass( 'not-active' );
				$( '.top-nav-bar .search' ).attr( 'title', 'Search site' );
				$( 'body' ).removeClass( 'fixed-body' );
			} );
		},

		_initSideMenu() {
			// Local menu

			const closeLocalMenu = () => {
				$( '.side-nav.navbar' ).slideUp( 200 );
				$( '.side-nav--mobile' ).removeClass( 'expanded' );
				$( '.side-nav--mobile' ).attr( 'aria-expanded', 'false' );
				$( '.side-nav--mobile' ).focus();
			};

			$( '.side-nav--mobile' ).click( ( e ) => {
				if ( $( '.side-nav.navbar' ).is( ':hidden' ) ) {
					$( '.hero-component-overlay' ).addClass( 'side-nav--open' );
					$( '.side-nav.navbar' ).slideDown( 200 );
					$( '.side-nav.navbar .nav-item:first-child a').focus();
					$( '.side-nav--mobile' ).addClass( 'expanded' );
					$( '.side-nav--mobile' ).attr( 'aria-expanded', 'true' );
				} else if ( $( '.side-nav.navbar' ).is( ':visible' ) ) {
					closeLocalMenu();
				}
			} );

			$( '.side-nav.navbar .nav-item a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					$(e.currentTarget).parent().next().find('a').focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					$(e.currentTarget).parent().prev().find('a').focus();
					e.preventDefault();
				}
			} );

			$( '.side-nav.navbar .nav-item:first-child a' ).keydown( (e) => {
				if (e.key === 'ArrowUp') {
					$( '.side-nav.navbar .nav-item:last-child a').focus();
					e.preventDefault();
				}
			} );

			$( '.side-nav.navbar .nav-item:last-child a' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					if( $('.side-nav--mobile.expanded').length > 0 ) {
						// Only if mobile menu is open.
						closeLocalMenu();
						e.preventDefault();
					}
				} else if (e.key === 'ArrowDown') {
					$( '.side-nav.navbar .nav-item:first-child a').focus();
					e.preventDefault();
				}
			} );

			$( '.side-nav--mobile, .side-nav.navbar a' ).keydown( (e) => {
				if( $('.side-nav--mobile.expanded').length > 0 ) {
					// Only if mobile menu is open.
					if (e.key === 'Esc' || e.key === 'Escape') {
						closeLocalMenu();
					}
				}
			} );

			// Skip to navigation link
			$('.skip-nav').click( (e) => {
				$( '.side-menu' ).removeClass( 'side-menu--hidden' );
				$( '.mobile-nav-button' ).attr('aria-expanded', 'true');
				$( '.menu-overlay' ).addClass( 'menu-overlay--visible' );
				$( 'body' ).addClass( 'fixed-body' );
				setTimeout(() => {
					$( '.side-menu button,.side-menu a' ).first().focus();
				}, 200);
				e.preventDefault();
			});

			// Close main menu on click
			$( document ).click( ( e ) => {
				if ( $( '.header .mobile-nav-button' )[ 0 ] === e.target || $( '.skip-links a' )[ 0 ] === e.target ) {
					return true;
				}

				if ( ! $( '.side-menu' ).hasClass( 'side-menu--hidden' ) ) {
					if ( ! e.target.closest( '.side-menu' ) && ! e.target.closest( '.nav-float' ) && ! e.target.closest('.mobile-nav-button') ) {
						console.log('close');
						closeMenu();
					}
				}
			} );

			let hierarchy = [];

			const closeMenu = () => {
				$( '.side-menu' ).addClass( 'side-menu--hidden' );
				hierarchy = [];
				setTimeout( () => {
					$( '.side-menu .back' ).hide();
					$( '.submenu' ).addClass( 'submenu--hidden' );
					$( '.subsubmenu' ).addClass( 'subsubmenu--hidden' );
					$( '.submenu a.active' ).removeClass( 'active' );
					$( '.subsubmenu-wrapper' ).hide();
					$( '.menu-wrapper' ).show();
					$( '.menu-overlay' ).removeClass( 'menu-overlay--visible' );
					$( 'body' ).removeClass( 'fixed-body' );
					$( '.mobile-nav-button' ).focus();
					$( '.mobile-nav-button' ).attr('aria-expanded', 'false');
					$( '.side-menu a[aria-expanded="true"], .submenu a[aria-expanded="true"], .subsubmenu a[aria-expanded="true"]' ).attr('aria-expanded', 'false');
					$( '.submenu[aria-hidden="false"], .subsubmenu[aria-hidden="false"' ).attr('aria-hidden', 'true');
				}, 200 );
			};

			// Open main menu
			$( 'body' ).on( 'click', '.mobile-nav-button', () => {
				if ( $( '.side-menu' ).hasClass( 'side-menu--hidden' ) ) {
					$( '.side-menu' ).removeClass( 'side-menu--hidden' );
					$( '.mobile-nav-button' ).attr('aria-expanded', 'true');
					$( '.menu-overlay' ).addClass( 'menu-overlay--visible' );
					$( 'body' ).addClass( 'fixed-body' );
					setTimeout(() => {
						$( '.side-menu button,.side-menu a' ).first().focus();
					}, 200);
				} else {
					closeMenu();
				}
			} );

			$( '.primary-menu-wrapper .close' ).keydown( (e) => {
				if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
					if( $('.menu-wrapper').is(':visible')) {
						$('.menu-wrapper .search-field').focus();
					} else {
						$('.submenu-wrapper .submenu:visible .menu-2 li:first-child a').focus();
					}
					e.preventDefault();
				} else if(e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
					$('.primary-menu-wrapper .logo').focus();
					e.preventDefault();
				}
			} );

			$( '.primary-menu-wrapper .logo' ).keydown( (e) => {
				if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
					$('.primary-menu-wrapper .close').focus();
					e.preventDefault();
				}
			} );


			$( '.menu-wrapper .menu-audience li:first-child a' ).keydown( (e) => {
				if (e.key === 'ArrowUp') {
					$('.menu-wrapper .search-field').focus();
					e.preventDefault();
				}
			} );

			// $( '.menu-wrapper .menu-3 li:last-child a' ).keydown( (e) => {
			//   if (e.key === 'ArrowDown') {
			//     $( '.menu-wrapper .menu:first-child li:first-child a' ).focus();
			//     e.preventDefault();
			//   }
			// } );

			$( 'body' ).on('keydown', '.submenu:visible .menu-2 li:first-child a', (e) => {
				if (e.key === 'ArrowUp') {
					$( '.side-menu .back' ).focus();
					e.preventDefault();
				}
			} );

			// $( 'body' ).on('keydown', '.submenu:visible .menu-3 li:last-child a', (e) => {
			//   if (e.key === 'ArrowDown') {
			//     $( '.submenu:visible .menu-2 li:first-child a' ).focus();
			//     e.preventDefault();
			//   }
			// } );

			$( '.menu-wrapper a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					let path = $(e.currentTarget).parent().next().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').nextAll('.menu').find('a').first();
					}
					path.focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					let path = $(e.currentTarget).parent().prev().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').prevAll('.menu').find('a').last();
					}
					path.focus();
					e.preventDefault();
				}
			} );

			$( '.submenu-wrapper a' ).keydown( (e) => {
				if (e.key === 'ArrowDown') {
					let path = $(e.currentTarget).parent().next().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').nextAll('.menu').find('a').first();
					}
					path.focus();
					e.preventDefault();
				} else if (e.key === 'ArrowUp') {
					let path = $(e.currentTarget).parent().prev().find('a');
					if(path.length === 0) {
						path = $(e.currentTarget).closest('.menu').prevAll('.menu').find('a').last();
					}
					path.focus();
					e.preventDefault();
				}
			} );

			// Close main menu options
			$( '.side-menu .close' ).click( () => {
				closeMenu();
			} );

			$( '.side-menu a, .side-menu button' ).keydown( (e) => {
				if (e.key === 'Esc' || e.key === 'Escape') {
					if( $( '.submenu:visible' ).length > 0 || $( '.subsubmenu:visible' ).length > 0 ) {
						backOne();
					} else {
						closeMenu();
					}
				}
			} );

			const backOne = () => {
				const newItem = hierarchy.pop();
				if ( newItem ) {
					if ( newItem.includes( 'subsubmenu' ) ) {
						// Tier 3
						$( '.side-menu a.active' ).removeClass( 'active' );
						$( '.subsubmenu-wrapper .subsubmenu' ).addClass(
							'subsubmenu--hidden'
						);
						$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu-wrapper' ).hide();
						if ( $( newItem ).length > 0 ) {
							// $( newItem ).removeClass( 'subsubmenu--hidden' );
							$( newItem ).attr( 'aria-hidden', 'true' );
							$( '.submenu-wrapper a[href="' + newItem + '"]').attr('aria-expanded', 'false');
							$( '.submenu-wrapper a[href="' + newItem + '"]').focus();
						}
					} else {
						// Tier 2
						$( '.submenu a.active' ).removeClass( 'active' );
						$( '.submenu:visible' ).addClass( 'submenu--hidden' );
						$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu:visible' ).addClass( 'subsubmenu--hidden' );
						$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
						$( '.subsubmenu-wrapper' ).fadeOut( 200 );
						$( newItem ).addClass( 'submenu--hidden' );
						$( newItem ).attr( 'aria-hidden', 'true' );

						setTimeout( () => {
							$( '.menu-wrapper' ).fadeIn( 200, function() {
								$( '.menu-wrapper a[href="' + newItem + '"]').attr('aria-expanded', 'false');
								$( '.menu-wrapper a[href="' + newItem + '"]').focus();
							} );
							$( '.side-menu .back' ).fadeOut( 200 );
						}, 200 );
					}
				} else {
					$( '.submenu a.active' ).removeClass( 'active' );
					$( '.submenu:visible' ).addClass( 'submenu--hidden' );
					$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
					$( '.subsubmenu:visible' ).addClass( 'subsubmenu--hidden' );
					$( '.subsubmenu-wrapper .subsubmenu' ).attr('aria-hidden', 'true');
					$( '.subsubmenu-wrapper' ).fadeOut( 200 );

					setTimeout( () => {
						$( '.menu-wrapper' ).fadeIn( 200 );
						$( '.side-menu .back' ).fadeOut( 200 );
					}, 200 );
				}
			}

			// Go back option
			$( '.side-menu .back' ).click( () => {
				backOne();
			} );

			// Open level 2 menu
			$( 'a[href^="#submenu"]' ).click( ( e ) => {
				$( '.submenu' ).addClass( 'submenu--hidden' );
				$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
				$( '.menu-wrapper' ).fadeOut( 200, () => {
					const submenu = $( e.currentTarget ).attr( 'href' );
					$( e.currentTarget ).attr('aria-expanded', 'true');
					hierarchy.push( submenu );
					$( submenu ).attr('aria-hidden', 'false');
					$( submenu ).removeClass( 'submenu--hidden' );
					$( submenu ).find('a').first().focus();
					$( '.side-menu .back' ).fadeIn( 200 );
				} );
				e.preventDefault();
			} );

			$( 'a[href^="#submenu"]' ).keydown( (e) => {
				if (e.key === 'ArrowRight') {
					$( '.submenu' ).addClass( 'submenu--hidden' );
					$( '.submenu-wrapper .submenu' ).attr('aria-hidden', 'true');
					$( '.menu-wrapper' ).fadeOut( 200, () => {
						const submenu = $( e.currentTarget ).attr( 'href' );
						$( e.currentTarget ).attr('aria-expanded', 'true');
						hierarchy.push( submenu );
						$( submenu ).attr('aria-hidden', 'false');
						$( submenu ).removeClass( 'submenu--hidden' );
						$( submenu ).find('a').first().focus();
						$( '.side-menu .back' ).fadeIn( 200 );
					} );
					e.preventDefault();
				} else if(e.key === 'ArrowLeft') {
					closeMenu();
				}
			} );

			$( 'body' ).on( 'keydown', '.submenu-wrapper .submenu:visible a', (e) => {
				if (e.key === 'ArrowLeft') {
					backOne();
					e.preventDefault();
				}
			} );

			$( 'body' ).on( 'keydown', '.subsubmenu-wrapper .subsubmenu:visible a', (e) => {
				if (e.key === 'ArrowLeft') {
					backOne();
					e.preventDefault();
				}
			} );

			$( '.menu-wrapper .menu:last-child li:last-child a' ).keydown( (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					closeMenu();
					e.preventDefault();
				}
			} );

			$( 'body' ).on('keydown', '.submenu:visible .menu:last-child li:last-child a', (e) => {
				if (e.key === 'Tab' && !e.shiftKey) {
					backOne();
					e.preventDefault();
				}
			} );
		},

		_initStickyMenu() {
			const header = document.getElementById('sticky-header');

			let startSticky = 100;

			if($('.header').height()) {
				startSticky = $('.header').height();
			}

			startSticky = 0;

			if( $('.alert-wrapper').length > 0  && $('.alert-wrapper').height()) {
				startSticky = startSticky + $('.alert-wrapper').height();
			}

			// console.log(startSticky);

			if( $('#wpadminbar').length > 0) {
				startSticky = startSticky + $('#wpadminbar').height();
			}

			window.addEventListener("scroll", () => {
				// console.log(scrollY);
				if (window.scrollY > startSticky) { // Adjust the scroll position where the change occurs
					header.classList.add('sticky');
				} else {
					header.classList.remove('sticky');
				}
			});
		},

		_initProgramFinder() {
			const searchInput = $('#search-input');
			const searchResults = $('#search-results');

			searchInput.on('input', function () {
					const query = $(this).val().trim();

					if (query.length === 0) {
							searchResults.empty();

							return;
					}

					// Make an AJAX request to the server to fetch search results
					$.ajax({
							url: '/wp-json/mside/v1/search-programs/', // Replace with the actual endpoint
							type: 'GET',
							data: {
									s: query,
									post_type: ['undergraduate', 'graduate'], // Replace with the actual post types
							},
					})
					.done(function(data) {
            displayResults(data);
	        })
	        .fail(function(jqXHR, textStatus, errorThrown) {
	            // Handle the failure, e.g., display an error message
	            searchResults.empty();
	            searchResults.append('<p class="error">An error occurred while fetching results.</p>');
	        });
			});

			function displayResults(results) {
					searchResults.empty();

					if (results.length === 0) {
							searchResults.append('<p class="no-results">No results found.</p>');
					} else {
							results.forEach(function (result) {
									const resultItem = $('<div class="result-item">');

									const resultLink = $('<a>');
									const resultPostType = $('<p class="finder-post-type">');
									resultLink.attr('href', result.permalink);
									resultLink.text(result.post_title);
									resultItem.append(resultLink);
									resultPostType.text(result.post_type);
									resultItem.append(resultPostType);

									searchResults.append(resultItem);
							});

							if (results.length > 0) {
								searchResults.addClass('search-results-column');
							}
					}
			}

		},
	};

	MsideScripts.init();
});
